import { useEffect, useState } from "react";

/** Re-render on an interval so computed occurrence status transitions without user interaction. */
export default function useEventStatusClock(enabled = true, intervalMs = 60000) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = window.setInterval(() => setTick((n) => n + 1), intervalMs);
    return () => window.clearInterval(id);
  }, [enabled, intervalMs]);
}
